export default "__VITE_ASSET__BDGZYJsA__"